"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialStatisticsList = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("../../../components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="tutorial-statistics-page">
    <div class="page-head">
        <div>
            <h1>${() => 'tutorial.statistics.title'.t()}</h1>
            <p>${() => 'tutorial.statistics.subtitle'.t()}</p>
        </div>
        <form class="search-form" @submit="${x => x.search()}">
            <input class="form-control" type="search"
                :value="${x => x.searchQuery}"
                @input="${(x, c) => x.onSearchInput(c.event)}"
                placeholder="${() => 'tutorial.searchPlaceholder'.t()}"
                aria-label="${() => 'tutorial.searchPlaceholder'.t()}">
            <button class="btn btn-primary" type="submit" ?disabled="${x => x.loading}">
                ${() => 'tutorial.statistics.search'.t()}
            </button>
        </form>
    </div>
    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader block="true"></app-loader>`)}
    ${(0, fast_element_1.when)(x => !!x.error, (0, fast_element_1.html) `
        <div class="alert alert-danger" role="alert">
            ${x => x.error}
            <button class="btn btn-outline-danger" @click="${x => x.loadData()}">
                ${() => 'tutorial.statistics.retry'.t()}
            </button>
        </div>
    `)}
    ${(0, fast_element_1.when)(x => !x.loading && !x.error, (0, fast_element_1.html) `
        ${(0, fast_element_1.when)(x => x.tutorials.length === 0, (0, fast_element_1.html) `
            <p class="empty-state">${() => 'tutorial.statistics.emptyTutorials'.t()}</p>
        `)}
        ${(0, fast_element_1.when)(x => x.tutorials.length > 0, (0, fast_element_1.html) `
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">${() => 'tutorial.statistics.tutorial'.t()}</th>
                            <th scope="col">${() => 'tutorial.statistics.category'.t()}</th>
                            <th scope="col">${() => 'tutorial.statistics.actions'.t()}</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${(0, fast_element_1.repeat)(x => x.tutorials, (0, fast_element_1.html) `
                            <tr>
                                <td><strong>${x => x.name}</strong><p>${x => x.description}</p></td>
                                <td>${x => { var _a; return ((_a = x.category) === null || _a === void 0 ? void 0 : _a.name) || 'tutorial.noCategory'.t(); }}</td>
                                <td>
                                    <button class="btn btn-outline-primary" @click="${(x, c) => c.parent.openStatistics(x)}">
                                        ${() => 'tutorial.statistics.viewParticipants'.t()}
                                    </button>
                                </td>
                            </tr>
                        `)}
                    </tbody>
                </table>
            </div>
        `)}
        <nav class="pagination-bar" aria-label="${() => 'tutorial.statistics.pagination'.t()}">
            <button class="btn btn-outline-secondary" ?disabled="${x => x.currentPage <= 1}"
                @click="${x => x.changePage(x.currentPage - 1)}">${() => 'tutorial.statistics.previous'.t()}</button>
            <span>${x => x.currentPage} / ${x => x.totalPages} (${x => x.count})</span>
            <button class="btn btn-outline-secondary" ?disabled="${x => x.currentPage >= x.totalPages}"
                @click="${x => x.changePage(x.currentPage + 1)}">${() => 'tutorial.statistics.next'.t()}</button>
        </nav>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.tutorial-statistics-page {
  padding: 1.5rem;
}
.tutorial-statistics-page .page-head, .tutorial-statistics-page .page-actions, .tutorial-statistics-page .search-form, .tutorial-statistics-page .pagination-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.tutorial-statistics-page .page-head {
  justify-content: space-between;
  margin-bottom: 1.5rem;
}
.tutorial-statistics-page .table-responsive {
  overflow-x: auto;
}
.tutorial-statistics-page .table {
  width: 100%;
}
.tutorial-statistics-page .table th, .tutorial-statistics-page .table td {
  padding: 1rem;
  vertical-align: middle;
}
.tutorial-statistics-page .table td p {
  margin: 0.5rem 0 0;
  max-width: 40rem;
}
.tutorial-statistics-page .progress {
  min-width: 8rem;
  height: 0.75rem;
  margin-bottom: 0.25rem;
}
.tutorial-statistics-page .empty-state {
  padding: 2rem;
  text-align: center;
}
.tutorial-statistics-page .pagination-bar {
  justify-content: center;
  margin-top: 1rem;
}`;
const shadowOptions = { "mode": "open" };
let TutorialStatisticsList = class TutorialStatisticsList extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tutorials = [];
        this.loading = false;
        this.error = '';
        this.searchQuery = '';
        this.currentPage = 1;
        this.totalPages = 1;
        this.count = 0;
        this.perPage = 20;
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadData();
    }
    async loadData() {
        if (this.loading)
            return;
        this.loading = true;
        this.error = '';
        this.tutorials = [];
        try {
            const query = this.searchQuery.trim();
            const response = await this.apiService.back.get('tutorial.list', {
                routeParams: query ? { q: query } : undefined,
                queryParams: {
                    p: String(this.currentPage),
                    per_page: String(this.perPage)
                }
            });
            if (!(response === null || response === void 0 ? void 0 : response.success) || !Array.isArray(response.data)) {
                throw new Error((response === null || response === void 0 ? void 0 : response.error) || 'tutorial.statistics.loadFailed'.t());
            }
            this.tutorials = response.data;
            this.count = response.count;
            this.totalPages = Math.max(1, Math.ceil(response.count / this.perPage));
        }
        catch (error) {
            console.error('Failed to load tutorial statistics list:', error);
            this.error = 'tutorial.statistics.loadFailed'.t();
            this.notifyService.notify(this.error, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    onSearchInput(event) {
        this.searchQuery = event.target.value;
    }
    async search() {
        if (this.loading)
            return;
        this.currentPage = 1;
        await this.loadData();
    }
    async changePage(page) {
        if (this.loading || page < 1 || page > this.totalPages)
            return;
        this.currentPage = page;
        await this.loadData();
    }
    openStatistics(tutorial) {
        component_1.SiteMenu.goto.bind(this)(`/settings/tutorial-statistics/${tutorial.id}`);
    }
};
exports.TutorialStatisticsList = TutorialStatisticsList;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialStatisticsList.prototype, "tutorials", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsList.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsList.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsList.prototype, "searchQuery", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsList.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsList.prototype, "totalPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsList.prototype, "count", void 0);
exports.TutorialStatisticsList = TutorialStatisticsList = __decorate([
    (0, client_1.RWSView)('tutorial-statistics-list', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TutorialStatisticsList);
TutorialStatisticsList.defineComponent();
